import React from 'react';
import { BaseLayerView } from '@/framework';
import { IRenderLayerProps } from '@/version-types';
import MarkupImage from './markup-image';

const MarkupLayer: React.FC<IRenderLayerProps> = ({ layer, isNavigator }) => {
    return (
        <BaseLayerView layer={layer} isNavigator={isNavigator} isOverflowHidden={!layer.__runtime?.isDrawPreview}>
            <MarkupImage layer={layer} />
        </BaseLayerView>
    );
};
export default React.memo(MarkupLayer);
